import { useState, useEffect } from 'react'
import { getProject } from '../api/projects'
import { Project } from '../types/index'

interface UseProjectReturn {
  project: Project | null
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

// Bug #328: this hook returned hard-coded mock data — `{ id, name: 'Sample
// Project', status: 'Active' }` after a 500ms setTimeout — and never called
// the API. Every project detail page in the platform therefore showed
// "Sample Project" with an otherwise empty overview, regardless of which
// project you opened or where it came from.
export const useProject = (id: string): UseProjectReturn => {
  const [project, setProject] = useState<Project | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchProject = async () => {
    if (!id) return
    setLoading(true)
    setError(null)
    try {
      setProject(await getProject(id))
    } catch (err) {
      setProject(null)
      setError(err instanceof Error ? err.message : 'Failed to load project')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void fetchProject()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return { project, loading, error, refetch: fetchProject }
}
